// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { CSSProperties, useMemo, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import S from './styles';

function useTabLine(tabs: string[], currentTab: string): [React.RefObject<HTMLDivElement>, CSSProperties | undefined] {
  const tabLine = useRef<HTMLDivElement>(null);

  const tabLineStyle = useMemo<CSSProperties | undefined>(() => {
    if (!tabLine.current || !tabLine.current.parentElement) return

    const index = tabs.indexOf(currentTab);
    const containerLeft = tabLine.current.parentElement.getBoundingClientRect().left;
    const { left, width } = tabLine.current.parentElement.children[index].getBoundingClientRect()

    return {
      left: (left - containerLeft) + 'px',
      width: width + 'px',
    }
  }, [tabLine.current, currentTab]);

  return [tabLine, tabLineStyle];
}

interface TabsProps extends React.ComponentPropsWithRef<'div'> {
  tabs: string[];
  currentTab: string;
  handleChangeTab: (tab: string) => void;
}

const Tabs: React.FC<TabsProps> = (props) => {
  const {
    tabs,
    currentTab,
    handleChangeTab,
    ...otherProps
  } = props;

  const [tabLine, tabLineStyle] = useTabLine(tabs, currentTab);

  return (
    <S.Container {...otherProps}>
      {
        tabs.map(tab => (
          <S.Tab
            isShown={currentTab == tab}
            key={tab}
            onClick={() => handleChangeTab(tab)}
          >
            <FormattedMessage
              description="Tab Name"
              id={tab}
            />
          </S.Tab>
        ))
      }
      <S.TabLine ref={tabLine} style={tabLineStyle} />
    </S.Container>
  )
}

export { Tabs as default }
